<template>
    <SelectTags
        :placeholder="placeholder"
        :size="size"
        :value.sync="valueComponent"
        :options="optionsComponent"
        :horizontal="horizontal"
        :label="label"
    />
</template>

<script>
import SelectTags from "£lement/SelectTags";
import axios from "axios";
export default {
    name: "SelectFormSponsors",
    components: {
        SelectTags,
    },
    data() {
        return {
            optionsComponent: [],
            valueComponent: null,
        };
    },
    props: {
        label: {
            type: String,
            default: null,
        },
        placeholder: {
            type: String,
            default: "Select item",
        },
        isValid: {
            type: Boolean,
            default: null,
        },
        size: {
            default: undefined,
        },
        horizontal:{
            default:false
        },

        value: {
            default: null,
        },
        optionsValue: {
            type: String | Function,
        } /* valueAttribute */,
        optionsLabel: {
            type: String | Function,
        } /* valueName */,

        form: {
            type: String | Object,
        },
    },
    watch: {
        valueComponent(newValue) {
            this.$emit("update:value", this.encodeValue(newValue));
            this.$emit("change", this.encodeValue(newValue));
            let option = this.optionsComponent.find((item) => {
                return item.value == newValue;
            });
            this.$emit("changeOption", option);
        },
        async form(newValue) {
            this.optionsComponent = await this.loadOptionsComponent();
            this.serializeData(this.optionsComponent);
        },
        value(newValue) {
            // this.valueComponent = this.decodeValue(newValue);
        },
    },
    methods: {
        decodeValue(value) {
            if(!value) return [];
            let newValue = value.map((item) => {
                let find = this.optionsComponent.find((option)=>{
                    return option.value == item;
                });
                if(find){
                    return find
                }
                return item;
            });
            return newValue;
        },
        encodeValue(value){
            if(!value) return [];
            return value.map((item) => {
                return item.value;
            })
        },
        serializeData(data) {
            let items = [];
            if (data.items) {
                items = data.items;
            } else if (data._items) {
                items = data._items;
            } else {
                items = data;
            }
            if (this.optionsValue && this.optionsLabel) {
                this.optionsComponent = items.map((item) => {
                    let value;
                    if (this.optionsValue instanceof Function) {
                        value = this.optionsValue(item);
                    } else {
                        value = item[this.optionsValue];
                    }

                    let text;
                    if (this.optionsLabel instanceof Function) {
                        text = this.optionsLabel(item);
                    } else {
                        text = item[this.optionsLabel];
                    }
                    return {
                        value,
                        text,
                        label: text,
                        name: text,
                    };
                });
            } else {
                this.optionsComponent = items.map((item) => {
                    return {
                        text: item,
                        value: item,
                        label: item,
                        name: item,
                    };
                });
            }
        },
        loadOptionsComponent: async function () {
            try {
                const { data } = await axios.get(
                    "/getSponsorByForm/" + this.form
                );
                return data;
            } catch (error) {
                console.log(error);
            }
        },
    },
    async mounted() {
        this.optionsComponent = await this.loadOptionsComponent();
        this.serializeData(this.optionsComponent);
        this.valueComponent = this.decodeValue(this.value);
    },
};
</script>

<style lang="scss">
</style>